export const declarationYears = [{
    label: '2022',
    value: '2022',
}, {
    label: '2023',
    value: '2023',
}]